









































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { getObsToken } from '../../../api/common/index';
import { UpdateCurrentUser } from '../../../api/enterprise/index';
import { GetUserInfo } from '../../../api/login/index';

import EditPwd from '../../../components/edit-password.vue';

@Component({
  name: 'PersonalSetting',
  components: { EditPwd },
})
export default class PersonalSetting extends Vue {
  setFormRef = null;
  uploadServer = '';
  setForm = {
    nickname: '',
    avatarUrl: '',
    mobile: '',
    department: '',
  };
  password = '123456';
  setFormRules = {};
  uploadPlayload = {};
  acceptImgType = '.png,.PNG, .jpg,.JPG, .JPEG,.jpeg';
  proviceList = [];
  cityList = [];
  disList = [];

  async mounted() {
    await this.getDetail();
  }

  async getDetail() {
    await GetUserInfo().then(res => {
      Object.keys(this.setForm).forEach(key => {
        (this.setForm as any)[key] = res[key];
      });
    });
  }

  handleUploadSuccess(res: any, file: any) {
    this.setForm.avatarUrl = file.raw.originalUrl;
  }

  async handleBeforeUpload(file: any) {
    try {
      let suffix = file.type.split('/')[1];
      let res = await getObsToken({ suffix });
      this.uploadServer = res.host;
      this.uploadPlayload = {
        key: res.key,
        policy: res.policy,
        signature: res.signature,
        AccessKeyId: res.accessid,
        success_action_status: '200',
      };
      file.originalUrl = res.cdn + res.key;
    } catch (e) {
      console.log(e);
    }
  }

  async handleUpdate() {
    await UpdateCurrentUser(this.setForm).then(() => {
      this.$message.success('更新成功');
    });
    await this.getDetail();
  }

  handleEdit() {
    (this.$refs.editPwdRef as any).$show();
  }
}
